import React from "react";
import { Link } from "react-router-dom";

const Productgrid = ({ product, goldPrice }) => {
  // Calculate price based on weight and making rate
  const calculatedPrice = goldPrice 
    ? (goldPrice / 8) * product.weight + (goldPrice * product.makingrate) / 100 
    : 0;

  return (
    <div className="group">
      <Link to={`/product/${product._id}`}>
        <div className="bg-white rounded-2xl overflow-hidden shadow-sm hover:shadow-2xl transition-all duration-500 transform hover:-translate-y-2 border border-gray-100">
          {/* Image Container */}
          <div className="relative aspect-square overflow-hidden bg-gray-50 uppercase tracking-widest text-sm font-semibold">
            <img
              className="w-full h-full object-cover transition-transform duration-700 group-hover:scale-110"
              src={product.images && product.images.length > 0 ? product.images[0].image : "/images/default_product.png"}
              alt={product.name}
            />
            
            {/* Luxury Badge */}
            <div className="absolute top-4 left-4 bg-white/90 backdrop-blur-md text-gray-900 px-3 py-1 rounded-full text-[10px] font-bold tracking-widest shadow-sm border border-gray-100 ">
              22K GOLD
            </div>

            {/* Sale Badge */}
            <div className="absolute top-4 right-4 bg-yellow-600 text-white px-3 py-1 rounded-full text-[10px] font-bold tracking-widest shadow-md">
              SALE
            </div>

            {/* Quick Action Overlay */}
            <div className="absolute inset-0 bg-black/5 opacity-0 group-hover:opacity-100 transition-opacity duration-300 flex items-center justify-center">
                <button className="bg-white text-gray-900 px-6 py-2 rounded-full font-bold text-sm transform translate-y-4 group-hover:translate-y-0 transition-transform duration-300 shadow-xl">
                    Quick View
                </button>
            </div>
          </div>

          {/* Product Info */}
          <div className="p-6 text-center">
            <div className="mb-1 text-[10px] text-yellow-600 font-bold tracking-[0.2em] uppercase">
                {product.category}
            </div>
            <h3 className="text-xl font-serif font-bold text-gray-900 mb-2 truncate group-hover:text-yellow-600 transition-colors">
              {product.name || "IGold Collection"}
            </h3>
            
            <div className="flex items-center justify-center space-x-2 mb-4">
                <span className="text-xs text-gray-400 bg-gray-50 px-2 py-0.5 rounded border border-gray-100">
                    {product.weight}g
                </span>
                <span className="text-xs text-gray-400 bg-gray-50 px-2 py-0.5 rounded border border-gray-100">
                    {product.makingrate}% VA
                </span>
            </div>

            <div className="flex flex-col items-center gap-4">
              <div className="text-2xl font-bold text-gray-900">
                {calculatedPrice > 0 ? (
                  <span className="flex flex-col">
                    <span className="text-sm text-gray-400 line-through font-normal opacity-50">
                        Rs {(calculatedPrice * 1.1).toLocaleString(undefined, { maximumFractionDigits: 0 })}
                    </span>
                    <span className="text-yellow-600">
                        Rs {calculatedPrice.toLocaleString(undefined, { maximumFractionDigits: 0 })}
                    </span>
                  </span>
                ) : (
                  <span className="text-sm text-gray-300 animate-pulse uppercase tracking-widest">Loading Price...</span>
                )}
              </div>

              <div className="w-full h-px bg-gray-100 mb-1"></div>

              <button className="w-full bg-gray-900 hover:bg-yellow-600 text-white text-sm font-bold py-3 px-6 rounded-xl transition-all duration-300 flex items-center justify-center space-x-2 group/btn shadow-lg hover:shadow-yellow-600/20">
                <span>View Details</span>
                <svg xmlns="http://www.w3.org/2000/svg" className="h-4 w-4 transform group-hover/btn:translate-x-1 transition-transform" fill="none" viewBox="0 0 24 24" stroke="currentColor">
                    <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M14 5l7 7m0 0l-7 7m7-7H3" />
                </svg>
              </button>
            </div>
          </div>
        </div>
      </Link>
    </div>
  );
};

export default Productgrid;
